import {createContext} from 'react';

import type {ChartLayoutState} from '../hooks/useChartLayout';

/** The chart layout of the page. Without it, every chart card has the full width. */
export const ChartLayoutContext = createContext<ChartLayoutState | null>(null);
